<template>
  <BaseModal
    :has-back-button="true"
    :has-mini-cart="true"
    :is-open="isOpen"
    :modal-modifier="'fullscreen'"
    @closed="close"
  >
    <TheProductDetails
      v-if="isOpen"
      :add-to-cart-url="addToCartUrl"
      :context="context"
      :loading="loading"
      :product="product"
      @zoomopen="isZoomOpen = true"
      @zoomclose="isZoomOpen = false"
    />
  </BaseModal>
</template>

<script>
import Axios from 'axios';
import getFrontConfig from '../../common/getFrontConfig';
import BaseModal from './BaseModal.vue';
import TheProductDetails from './TheProductDetails.vue';
import EventBusConfig from '../config/eventBusConfig';
import { mergeProducts } from '../../common/helpers/productModelHelpers';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'ThePDPModal',

  components: {
    BaseModal,
    TheProductDetails,
  },

  // Avoid browser navigating back if zoom is open and close it instead
  beforeRouteLeave(to, from, next) {
    if (this.isZoomOpen) {
      next(false);
    } else {
      next();
    }
  },

  props: {
    productTile: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    addToCartUrl: FRONT_CONFIG.urls.addToCart,
    context: FRONT_CONFIG.vue.TheProductDetails.context.modal,
    isOpen: false,
    isZoomOpen: false,
    partialInitialProduct: null,
    fullProduct: null,
    productShowUrl: FRONT_CONFIG.urls.productShow,
  }),

  computed: {
    product() {
      if (this.fullProduct && this.fullProduct.id === this.partialInitialProduct?.id) {
        return this.fullProduct;
      }
      return this.partialInitialProduct;
    },
    loading() {
      return this.fullProduct?.id !== this.partialInitialProduct?.id;
    },
  },

  watch: {
    product(newProduct) {
      this.isOpen = newProduct !== null;
    },
    productTile(newProduct) {
      if (newProduct === null) {
        this.partialInitialProduct = null;
      } else {
        this.partialInitialProduct = { ...newProduct };
      }
    },
    partialInitialProduct(newProduct) {
      if (newProduct && newProduct.id !== this.fullProduct?.id) {
        Axios.get(this.productShowUrl, {
          params: {
            format: 'json',
            pid: newProduct.id,
          },
        }).then((response) => {
          this.fullProduct = response.data.product;
        });
      }
    },
  },

  mounted() {
    this.$eventBus.$on(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleUpdateProductCommand,
    );
  },

  beforeDestroy() {
    this.$eventBus.$off(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleUpdateProductCommand,
    );
  },

  methods: {
    close() {
      this.isOpen = false;
      this.$emit('closed');
    },
    handleUpdateProductCommand({ product, container }) {
      if (container.dataset.context === this.context) {
        /*
        Next line is not orthodox, as it modifies the incoming prop. By the way,
        this has a side effect, the search results shows the last variation that
        has been shown. Although, this could be desirable, so it isn't the worst
        side effect.
        */
        this.partialInitialProduct = mergeProducts(this.partialInitialProduct, product);
        this.fullProduct = mergeProducts(this.fullProduct, product);
      }
    },
  },
};
</script>
